import React, { useState } from 'react';

import { RCChip, RCPopover } from '@reverbdotcom/cadence/components';
import { SearchRemixer_SortFieldsFragment } from '@reverbdotcom/commons/src/gql/graphql';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import classNames from 'classnames';

interface IProps {
  loading: boolean;
  sorts: SearchRemixer_SortFieldsFragment;
}

export function SortChip({ loading, sorts }: IProps) {
  const [isPopoverOpen, openPopover] = useState(false);

  if (loading && !sorts) {
    return (
      <div className="mobile-d-none">
        <RCChip
          key="sort"
          loading
        >
          <div className="filter-chip__loading-placeholder" />
        </RCChip>
      </div>
    );
  }

  if (!sorts) return null;

  const selected = sorts?.sortOptions.find(opt => opt.selected);
  return (
    <div className="mobile-d-none">
      <RCPopover
        isOpen={isPopoverOpen}
        onDismiss={() => openPopover(false)}
        loading={loading}
        trapFocus
        anchor={
          <RCChip
            loading={loading}
            onClick={() => openPopover(!isPopoverOpen)}
          >
            <span>
              <span className="weight-normal">{`${sorts.displayText}: `}</span>
              {selected?.displayName || ''}
            </span>
          </RCChip>
        }
      >
        <SortOption
          sorts={sorts}
        />
      </RCPopover>
    </div>
  );
}

function SortOption({ sorts }: { sorts: SearchRemixer_SortFieldsFragment }) {
  return (
    <div className="sort" data-testid={`sort-group_${sorts.displayText}`}>
      <h3 className="sort__heading">{sorts.displayText}</h3>
      <ul className="sort__options">
        {
          sorts.sortOptions.map((sortOption) => {
            const classes = classNames('sort__option', {
              'sort__option--active ': sortOption.selected,
            });
            return (
              <div className={classes} key={`${sorts.displayText}-${sortOption.displayName}`}>
                <CoreLink
                  to={sortOption.searchUrl}
                  className={sortOption.selected ? 'sort__link sort__link--active' : 'sort__link'}
                >
                  <div>
                    <span className="mr-space">{sortOption.displayName}</span>
                  </div>
                </CoreLink>
              </div>
            );
          })
        }
      </ul>
    </div>
  );
}
